class EmailChecker {
  load() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://cdnjs.cloudflare.com/ajax/libs/mailcheck/1.1.2/mailcheck.min.js`
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })
  }

  async run(email) {
    if (!window.Mailcheck) await this.load()
    return window.Mailcheck.run(email)
  }
}

export default new EmailChecker()
